import { PayloadAction, createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { IPosSection } from "amnRestaurants/tableOrders/posSection";
import { RestTableDto } from "amnRestaurants/tableOrders/restTable";
import { RootState } from "app/store";
import { NIL, NIL as uuidNil } from "uuid";
import tableOrdersApi from "api/tableOrdersApi";

export interface TableOrderState {
  section: IPosSection | null;
  tables: RestTableDto[];
  selectedTable: RestTableDto | null;
  isTableSelectedFromDrawer: boolean;
}

var initialState: TableOrderState = {
  section: null,
  tables: [],
  selectedTable: null,
  isTableSelectedFromDrawer: false,
};

// Function to normalize tables data
const normalizeTables = (apiTables: any[]): RestTableDto[] => {
  return (apiTables || []).map((t: any) => {
    const normalized: RestTableDto = {
      tableId: t.tableId,
      tableNumber: t.tableNumber,
      shape: t.shape,
      size: t.size,
      position: t.position,
      seats: t.seats,
      isOccupied: t.isOccupied,
      currentOrder: t.currentOrder,
    };
    return normalized;
  });
};

// Async thunk to refresh tables
export const refreshTables = createAsyncThunk(
  "tableOrder/refreshTables",
  async (sectionId: string, { rejectWithValue }) => {
    try {
      const response = await tableOrdersApi.getTablesSections(sectionId);
      return normalizeTables(response.data || []);
    } catch (error: any) {
      console.error("Failed to refresh tables:", error);
      return rejectWithValue(
        error.response?.data || "Failed to refresh tables"
      );
    }
  }
);

export const tableOrderSlice = createSlice({
  name: "TableOrderSlice",
  initialState,
  reducers: {
    initialize: (state) => {
      return state;
    },

    onSetSectionId: (state, action: PayloadAction<IPosSection>) => {
      state.section = action.payload;
    },

    onSetTables: (state, action: PayloadAction<RestTableDto[]>) => {
      state.tables = action.payload;
    },

    onSetSelectedTable: (state, action: PayloadAction<RestTableDto | null>) => {
      state.selectedTable = action.payload;
    },

    onSetTableSelectedFromDrawer: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isTableSelectedFromDrawer = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(refreshTables.fulfilled, (state, action) => {
        state.tables = action.payload;
      })
      .addCase(refreshTables.rejected, (state, action) => {
        // Keep existing tables on error, just log it
        console.error("Refresh tables failed:", action.payload);
      });
  },
});

export const { initialize, onSetSectionId, onSetTables, onSetSelectedTable, onSetTableSelectedFromDrawer } =
  tableOrderSlice.actions;

export const restMenu = (state: RootState) => state.restMenu;

export default tableOrderSlice.reducer;
